/**
 * Per-module DiSC persona alignment.
 * Each module slug maps to the DiSC style that best matches the buyer
 * mindset that module is designed for. Default falls back to "D" — same
 * Driver framing the page used before the per-module pass.
 *
 * Used by ModulePage to tune the DiscChapter chip + PainPoints stat set
 * per individual module page (so /products/kai feels different from
 * /products/clinic-pulse — instead of every module reading like Driver content).
 */

export const MODULE_DISC = {
  // Bases — calm, foundational, "one calm system"
  "hub":              { disc: "S", stats: "DEFAULT" },
  "hub-plus":         { disc: "S", stats: "DEFAULT" },

  // Growth / scaling — Driver framing
  "ai-workforce":     { disc: "D", stats: "GROWTH" },
  "sales-autopilot":  { disc: "D", stats: "GROWTH" },
  "growth":           { disc: "D", stats: "GROWTH" },

  // Conversation / patient comms — Influencer framing
  "call-iq-ai":       { disc: "i", stats: "COMMS" },
  "kai":              { disc: "i", stats: "COMMS" },
  "copilot":          { disc: "i", stats: "COMMS" },
  "review-ai":        { disc: "i", stats: "COMMS" },
  "reactivation":     { disc: "i", stats: "COMMS" },

  // Data / analytics / ops — Conscientious framing
  "clinic-pulse":     { disc: "C", stats: "DATA" },
  "automations":      { disc: "C", stats: "DATA" },
  "payments":         { disc: "C", stats: "DATA" },

  // Training / human-touch — Steady
  "academy":          { disc: "S", stats: "DEFAULT" },
};

/* Default fallback for unrecognized slugs — keeps Driver framing. */
export const MODULE_DISC_DEFAULT = { disc: "D", stats: "DEFAULT" };

/* Helper — returns { disc, stats } for a given slug. */
export function moduleDiscFor(slug) {
  return MODULE_DISC[slug] || MODULE_DISC_DEFAULT;
}
